(() => {
  'use strict';
  const init=()=>{
    const offer=document.getElementById('offer'),header=document.getElementById('shopify-section-unc-header');
    if(!offer || !/^\/pages\/chelate-x(?:-v[1-3])?$/.test(location.pathname))return;
    const measure=()=>document.documentElement.style.setProperty('--unc-offer-offset',Math.ceil(header?.getBoundingClientRect().height || 90)+16+'px');
    measure();if(header && 'ResizeObserver' in window)new ResizeObserver(measure).observe(header);
    window.addEventListener('click',event=>{
      const link=event.target.closest?.('a[href="#offer"]');
      if(!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)return;
      event.preventDefault();event.stopImmediatePropagation();measure();
      if(window.UnchemedAnchorScroll){window.UnchemedAnchorScroll.go(offer,{behavior:'smooth'});return;}
      offer.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      history.replaceState(null,'','#offer');
    },true);
    if(location.hash!=='#offer')return;
    try{if('scrollRestoration' in history)history.scrollRestoration='manual';}catch(e){}
    const root=document.documentElement,events=['touchstart','pointerdown','wheel','keydown'];
    let done=false,timer=0,observer=null;
    const stop=()=>{if(done)return;done=true;clearInterval(timer);observer&&observer.disconnect();events.forEach(type=>window.removeEventListener(type,stop,true));};
    let loaded=document.readyState==='complete',stableSince=0;
    const align=()=>{
      if(done)return;measure();
      const margin=parseFloat(getComputedStyle(offer).scrollMarginTop)||0;
      const delta=offer.getBoundingClientRect().top-margin;
      const now=Date.now();
      if(Math.abs(delta)<3){if(!stableSince)stableSince=now;if(loaded&&now-stableSince>=3000)stop();return;}
      stableSince=0;
      const previous=root.style.scrollBehavior;root.style.scrollBehavior='auto';
      window.scrollTo(0,Math.max(0,window.scrollY+delta));
      root.style.scrollBehavior=previous;
    };
    events.forEach(type=>window.addEventListener(type,stop,{capture:true,passive:true}));
    align();requestAnimationFrame(align);
    if('ResizeObserver' in window){observer=new ResizeObserver(align);observer.observe(document.body);}
    timer=setInterval(align,250);
    window.addEventListener('load',()=>{loaded=true;align();},{once:true});
    setTimeout(stop,30000);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

/* unc-smooth-warmup 2026-10-16: start poster + lazy-image downloads ~2.5 screens before they scroll into view,
   so media is already painted when it arrives (boxes are reserved; this never changes layout). */
(()=>{
  'use strict';
  if(!/^\/pages\/chelate-x(?:-v[1-3])?$/.test(location.pathname) || !('IntersectionObserver' in window))return;
  const margin=Math.round(Math.max(window.innerHeight||800,600)*2.5)+'px 0px';
  const posters=()=>{
    const list=document.querySelectorAll('video[data-unc-poster]');
    if(!list.length)return;
    const io=new IntersectionObserver(entries=>entries.forEach(e=>{
      if(!e.isIntersecting)return;io.unobserve(e.target);
      const p=e.target.getAttribute('data-unc-poster');
      if(p){e.target.setAttribute('poster',p);e.target.removeAttribute('data-unc-poster');}
    }),{rootMargin:margin});
    list.forEach(v=>io.observe(v));
  };
  const images=()=>{
    const list=document.querySelectorAll('main img[loading="lazy"]');
    if(!list.length)return;
    const io=new IntersectionObserver(entries=>entries.forEach(e=>{
      if(!e.isIntersecting)return;io.unobserve(e.target);e.target.loading='eager';
    }),{rootMargin:margin});
    list.forEach(img=>io.observe(img));
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',posters,{once:true});else posters();
  if(document.readyState==='complete')images();else window.addEventListener('load',images,{once:true});
})();
